import {
  duration,
  fadeIn
} from "./chunk-X5OIVVU7.js";
import {
  Icon
} from "./chunk-7IEFGXFA.js";

// src/components/canvas/editor/SaveStatusIcon.tsx
import { motion, AnimatePresence } from "motion/react";
import { jsx, jsxs } from "react/jsx-runtime";
function SaveStatusIcon({ saveState }) {
  const { isSaving, lastSaved, pendingChanges, error } = saveState;
  const hasActivity = isSaving || pendingChanges || error || lastSaved;
  if (!hasActivity) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", { className: "flex items-center flex-shrink-0", children: /* @__PURE__ */ jsxs(AnimatePresence, { mode: "wait", children: [
    error && /* @__PURE__ */ jsx(motion.div, { ...fadeIn, transition: { duration: duration.fast }, children: /* @__PURE__ */ jsx(Icon, { name: "alert-circle", className: "h-3 w-3 text-destructive" }) }, "error"),
    !error && isSaving && /* @__PURE__ */ jsx(motion.div, { ...fadeIn, transition: { duration: duration.fast }, children: /* @__PURE__ */ jsx("div", { className: "animate-spin h-2.5 w-2.5 border-[1.5px] border-primary border-t-transparent rounded-full" }) }, "saving"),
    !error && !isSaving && pendingChanges && /* @__PURE__ */ jsx(motion.div, { ...fadeIn, transition: { duration: duration.fast }, children: /* @__PURE__ */ jsx("div", { className: "h-1.5 w-1.5 rounded-full bg-amber-500" }) }, "pending"),
    !error && !isSaving && !pendingChanges && lastSaved && /* @__PURE__ */ jsx(motion.div, { ...fadeIn, transition: { duration: duration.fast }, children: /* @__PURE__ */ jsx(Icon, { name: "check", className: "h-3 w-3 text-green-500" }) }, "saved")
  ] }) });
}

export {
  SaveStatusIcon
};
//# sourceMappingURL=chunk-SRZWD5ZB.js.map